import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {getProducts} from "../../actions/Products";
import './wines.css'

function WinesList() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [wines, setWines] = useState<any[]>([]);

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    useEffect(() => {
        getProducts()
            .then(response => {
                setWines(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch products:", error);
            });
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const postsPerPage = 100;

    // Pagination helpers
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = wines.slice(indexOfFirstPost, indexOfLastPost);
    const totalPages = Math.ceil(wines.length / postsPerPage);

    const handlePageChange = (pageNumber: number) => {
        setCurrentPage(pageNumber);
    };


    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className="content-form-button right-align" style={{marginTop: "10px", marginRight: "15px"}}>
                <button
                    type="button"
                    className="button button-right"
                    onClick={() => navigate('/dashboard/wines/brands', { state: { user } })}
                    style={{ marginRight: "10px, marginTop: 10px" }}
                >
                    Brands
                </button>
            </div>

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>

                {/* News Posts Table */}
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "8%" }}>Stock Code</th>
                            <th style={{ width: "32%" }}>Name</th>
                            <th style={{ width: "15%" }}>Brand</th>
                            <th style={{ width: "10%" }}>Year</th>
                            <th style={{width: "17"}}>Cultivar</th>
                            <th style={{ width: "7%" }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {currentPosts.map((post) => (
                            <tr key={post.id}>
                                <td>{post.stock_code}</td>
                                <td>{post.name}</td>
                                <td>{post.brand.name}</td>

                                <td>{post.year}</td>
                                <td>{post.cultivator.name}</td>
                                <td>
                                    <button
                                        className="button small"
                                        // onClick={() => navigate(`/dashboard/news/${post.template_id}/${post.id}/edit`, { state: { user } })}
                                        onClick={() => navigate('/dashboard/wines/show', { state: { user: user, wine: post } })}
                                        style={{ marginRight: "10px" }}
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
                            <button
                                key={pageNumber}
                                className={`pagination-button ${currentPage === pageNumber ? "active" : ""}`}
                                onClick={() => handlePageChange(pageNumber)}
                            >
                                {pageNumber}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WinesList;
